// import "./markup-menu";
import $ from 'jquery'
import sliders from './components/sliders'
import 'malihu-custom-scrollbar-plugin'
import Tabs from "./components/tabs";
import 'jquery-mousewheel'
import socialLikes from 'social-likes-next';
import { map } from './components/map';
import animations from './components/animations';
global.$ = global.jQuery = $
require("./components/open-close");
function initOpenClose() {
  jQuery(".careers__list li").openClose({
    hideOnClickOutside: false,
    activeClass: "active",
    opener: ".opener",
    slider: ".slide",
    animSpeed: 200,
    effect: "slide"
  });
}
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    animations();
  }, 700);
  sliders();
  initOpenClose();
  map();
  $('.review__text').mCustomScrollbar();
  $('.products').mouseover(function() {
    $(this).removeClass('hover');
  });

  $('.products').mouseout(function() {
    $(this).addClass('hover');
  });
  new Tabs();
  $('.top-section__buttons .button').on('click', function(e) {
      e.preventDefault();
      var idBlock = $(this).attr('href');
      var idTop = $(idBlock).offset().top - 100;
      $('html, body').stop().animate({
          scrollTop: idTop
      }, 1000);
  });
  if ($('.career-inner__field').val() !== '') {
      $('.career-inner__field').addClass('val');
    } else {
      $('.career-inner__field').removeClass('val');
   }
   $('.career-inner__field').on('blur keyup', function () {
    if ($(this).val() !== '') {
        $(this).addClass('val');
      } else {
        $(this).removeClass('val');
     }
   });
   if ($('.career-inner__area').val() !== '') {
       $('.career-inner__area').addClass('val');
     } else {
       $('.career-inner__area').removeClass('val');
    }
    $('.career-inner__area').on('blur keyup', function () {
     if ($(this).val() !== '') {
         $(this).addClass('val');
       } else {
         $(this).removeClass('val');
      }
    });
    $('.menu-opener').click(function() {
        $(this).toggleClass('active');
        $('.nav').toggleClass('show');
    });
    $('.popup__cancel, .popup__close, .popup__overlay').click(function() {
        $('.popup').css('display', 'none');
    });
    $('#uploadfiles').on('change', function () {
      if ($(this).val().lastIndexOf('\\')) {
        var n = $(this).val().lastIndexOf('\\') + 1;
      } else {
        var n = $(this).val().lastIndexOf('/') + 1;
      }

      let fileName = $(this).val().slice(n);
      const inner = $('.file-name__inner');
      const current = $('.file-name__current');

      inner.addClass('show');
      current.text(fileName);
      $('.file-name__remove').on('click', () => {
        $('#uploadfiles').val('');
        if ($('#uploadfiles').val('')) {
          current.text('');
          inner.removeClass('show');
        }
      });
    });
});



// WEBPACK FOOTER //
// app/scripts/index.js